"use client";
import { MinimalAudioSkin as MinimalAudioSkin$1 } from "../../internal/skins/minimal-audio/skin.js";
import { jsx } from "react/jsx-runtime";
//#region src/presets/audio/minimal-skin.tsx
function MinimalAudioSkin(props) {
	return /* @__PURE__ */ jsx(MinimalAudioSkin$1, { ...props });
}
//#endregion
export { MinimalAudioSkin };

//# sourceMappingURL=minimal-skin.js.map